<template>
	<b-modal id="modalRegistroOfertaDisponible" v-model="$parent.modalRegistroOfertaDisponible" @show="getGrupos()"
		@hide="resetModal()" hide-footer centered size="lg" hide-header-close :no-close-on-backdrop="clicked"
		:no-close-on-esc="clicked">

		<!-- HEADER CUSTOM -->
		<template #modal-header="{ close }">

			<div class="d-flex justify-content-between align-items-center w-100">

				<h5 class="mb-0">
					Registro a {{ ofertaSelected.nombre_curso }}
				</h5>

				<button type="button" class="btn btn-sm btn-light rounded-circle px-2" @click="close()" :disabled="clicked">
					✕
				</button>

			</div>

		</template>

		<div class="px-3 py-2">

			<!-- SELECCIÓN DE GRUPO -->
			<div v-if="grupos && grupos.length > 0">

				<b-form-group label="Selecciona un grupo disponible" label-class="fw-bold mb-3">

					<div v-for="grupo in grupos" :key="grupo.id_grupo"
						class="border rounded p-3 mb-2 d-flex align-items-start">

						<b-form-radio v-model="grupoSelected" name="grupos" :value="grupo.id_grupo" class="me-3 mt-1" />

						<div>

							<div class="fw-semibold">
								{{ grupo.grupo }}
							</div>

							<small class="text-muted">
								{{ grupo.observacion }}
							</small>

						</div>

					</div>

				</b-form-group>

			</div>

			<!-- SIN GRUPOS -->
			<div v-else class="text-center py-4">

				<strong class="text-danger">
					Lo sentimos, no hay grupos disponibles :(
				</strong>

			</div>

			<!-- ACCIONES -->
			<div class="d-flex justify-content-end gap-2 mt-4">

				<button type="button" class="btn bg-1" @click="registroOferta()" :disabled="clicked || !grupoSelected">

					<span v-if="clicked">

						<span class="spinner-border spinner-border-sm me-2" role="status"></span>

						Procesando...

					</span>

					<span v-else>

						Registrarme

					</span>

				</button>

				<button type="button" class="btn bg-2" @click="$parent.modalRegistroOfertaDisponible = false"
					:disabled="clicked">

					Cancelar

				</button>

				<button type="button" class="btn bg-4" v-if="finalizar && !clicked" @click="finalizarsol()">

					Finalizar

				</button>

			</div>

		</div>

	</b-modal>
</template>
  

<script>
//import axios from 'axios';
import { queryIEASIS } from '../backIeasis/dbContextConexion';
import { alert } from "@/assets/functions";
import axios from "axios"



export default {
	name: 'RegistroOfertaDisponibleModal',
	props: {
		ofertaSelected: Object,
	},
	data() {
		return {
			clicked: false,
			finalizar: false,
			grupos: [],
			estatus: '',
			grupoSelected: '',
			registro: {
				oferta_formacion: '',
				usuario: '',
				grupo: '',
				nombre_oferta: '',
				fecha_ini: '',
				hora_ini: ''
			},
			email: '',

			//Cupo máximo de la Oferta
			cupomaxoferta: null,
			registrosoferta: null,

			//Cupo por Grupo
			cupo: null,
			contador: null,
		};
	},
	mounted() {
		this.email = localStorage.getItem("email")
		console.log('ofertaSelected:', this.ofertaSelected);

	},
	methods: {
		async getGrupos() {
			this.grupos = [];
			for (var i in this.ofertaSelected.grupos) {
				if (this.ofertaSelected.grupos[i].estatus == 'INSCRIPCION ABIERTA' || this.ofertaSelected.grupos[i].estatus == 'INSCRIPCIÓN ABIERTA' || this.ofertaSelected.grupos[i].estatus == 'Inscripción Abierta' || this.ofertaSelected.grupos[i].estatus == 'Inscripcion Abierta') {
					this.grupos.push(this.ofertaSelected.grupos[i]);
				}
			}
		},
		async registroOferta() {

			console.clear();

			//---------------------------------------------------
			// VALIDAR GRUPO
			//---------------------------------------------------

			if (!this.grupoSelected) {

				alert(
					'Debes seleccionar un grupo disponible',
					'danger'
				);
				return;
			}

			//---------------------------------------------------
			// DATOS REGISTRO
			//---------------------------------------------------

			this.registro.oferta_formacion = this.ofertaSelected.id_oferta;
			this.registro.usuario = sessionStorage.getItem('id');
			this.registro.curp = sessionStorage.getItem('usuario');
			this.registro.grupo = this.grupoSelected;
			this.registro.nombre_oferta = this.ofertaSelected.nombre_curso;


			const query2 = "SELECT * FROM oferta_formacion where id_oferta = " + this.registro.oferta_formacion
			const res2 = await queryIEASIS(query2)
			this.registro.fecha_ini = res2[0].fecha_ini

			//this.registro.fecha_ini = this.ofertaSelected.fecha_ini;
			console.log('ofertaSelected:', this.ofertaSelected);
			console.log('fecha_ini:', this.registro.fecha_ini);


			//---------------------------------------------------
			// VALIDAR USUARIO
			//---------------------------------------------------

			if (!this.registro.usuario) {

				alert(
					'Error al procesar tu usuario(Sesión Expirada y/o Problema con Navegador)',
					'danger'
				);

				return;

			}

			//---------------------------------------------------
			// BLOQUEAR BOTÓN
			//---------------------------------------------------

			this.clicked = true;

			try {

				console.log('INICIANDO REGISTRO');

				//---------------------------------------------------
				// INICIO DE REGISTRO
				//---------------------------------------------------

				const query =
					"EXEC sp_registrar_usuario " +
					"@idusuario = " + this.registro.usuario + ", " +
					"@id_oferta = " + this.registro.oferta_formacion + ", " +
					"@id_grupo = " + this.registro.grupo;

				//---------------------------------------------------
				// EJECUTAR
				//---------------------------------------------------

				const res = await queryIEASIS(query);

				console.log(res);

				//---------------------------------------------------
				// VALIDAR RESPUESTA
				//---------------------------------------------------
				if (!res || !res[0]) {

					alert(
						'No se recibió respuesta del servidor, favor de intentar nuevamente',
						'danger'
					);

					return;
				}


				if (res[0].success == 1) {

					//---------------------------------------------------
					// ÉXITO
					//---------------------------------------------------

					alert(
						res[0].mensaje,
						'success'
					);

					console.log(
						'ID REGISTRO:',
						res[0].idregistro
					);

					//---------------------------------------------------
					// MOSTRAR BOTÓN FINALIZAR
					//---------------------------------------------------

					this.finalizar = true;

					//---------------------------------------------------
					// ENVIAR EMAIL
					//---------------------------------------------------

					this.enviaremail();

				} else {

					//---------------------------------------------------
					// ERROR CONTROLADO SP
					//---------------------------------------------------

					alert(
						res[0].mensaje,
						'danger'
					);

				}

			} catch (error) {

				//---------------------------------------------------
				// ERROR GENERAL
				//---------------------------------------------------

				console.error(error);

				alert(
					'Ocurrió un error al procesar tu registro',
					'danger'
				);

			} finally {

				//---------------------------------------------------
				// DESBLOQUEAR BOTÓN
				//---------------------------------------------------

				this.clicked = false;

			}

		},
		enviaremail() {
			//SERVICIO DE ENVIO DE EMAIL DE CONFIRMACIÓN A INSCRIPCIÓN DE CURSO			
			axios.post(
				"https://servicios.iea.edu.mx/ieaws/googleapis/gmail/send",
				{
					"to": this.email,
					"subject": "[ACUSE] Confirmación de Registro al Curso SIFC: " + this.registro.nombre_oferta,
					"htmlBody":
						"   <b><p>¡FELICIDADES! Te has inscrito a la acción de formación : " + this.registro.nombre_oferta + " , que inicia el día " + this.registro.fecha_ini.substring(8, 10) + "/" + this.registro.fecha_ini.substring(5, 7) + "/" + this.registro.fecha_ini.substring(0, 4) + ".</p> </b>" +
						"   <p> </p>    " +
						"   <b><p>Posteriormente, recibirás un correo de bienvenida por parte de la instancia que oferta la acción formativa, con las indicaciones necesarias.</p></b> " +
						"   <p> <p/>    " +
						"   <b><p>Mantente atento a tu correo institucional, en caso de no recibir el correo de bienvenida por la instancia previo al inicio de la acción formativa, comunicate al 449 910 5600 ext. 4319 o 4345. </p> </b>" +
						"   <p> <p/>    " +
						"   <b><p>Celebramos el interés por seguir formándote.<p/> </b>" +
						"   <p> <p/>    " +
						"   <b><p>La educación es el arma más poderosa que puedes usar para cambiar el mundo.<p/></b>" +
						"   <p> <p/>    " +
						"   <p> <p/>    " +
						"   <b><p>~Nelson Mandela<p/></b>"
				},
				{
					headers: {
						"Content-Type": "application/json",
						"X-Api-Key": "87df8db5efcb83f16830e0112424d528c181d44540f841ca6908ee71faaedafc"
					}
				})
				.then((response) => {
					console.log(response);
				})
				.catch((error) => {
					console.log(error);
				});


		},
		resetModal() {
			this.finalizar = false;
			this.clicked = false;
			this.grupos = [];
			this.grupoSelected = '';
		},
		finalizarsol() {
			this.grupos = [];
			this.grupoSelected = '';
			window.location.reload(true);
			//this.$router.push('#/dashboard/miFormacion')
		}

	},
};
</script>
